// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul.style-module_items_XBlroYgs77l4rLo1WtE3 li {
  padding: 0.4rem 0.6rem;
  cursor: pointer;
}

ul.style-module_items_XBlroYgs77l4rLo1WtE3 li span {
  margin-left: 0.5rem;
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/components/PopupMenu/style.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;EACA,qBAAA;AACF","sourcesContent":["ul.items li{\n  padding: 0.4rem 0.6rem;\n  cursor: pointer;\n}\n\nul.items li span{\n  margin-left: 0.5rem;\n  display: inline-block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"items": `style-module_items_XBlroYgs77l4rLo1WtE3`
};
export default ___CSS_LOADER_EXPORT___;
